import { render, staticRenderFns } from "./introduces.vue?vue&type=template&id=00abf562&scoped=true&"
import script from "./introduces.vue?vue&type=script&lang=ts&"
export * from "./introduces.vue?vue&type=script&lang=ts&"
import style0 from "./introduces.vue?vue&type=style&index=0&id=00abf562&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abf562",
  null
  
)

export default component.exports